import React, { Component } from 'react'

export default class
    About
    extends Component {
    render() {
        return (
            <div className="container">
                <h1 className="white-text"> About us</h1>
                <h6 className="white-text"> Our Mission</h6>
                <span>
                    WelfareX is providing trained aya care, child care, wellness and various other at-home services in Kolkata and surrounding areas.
                    Our service providers are vastly experienced and trained in their area of expertise and facilitate delivering essential services in a professional, prompt and hassle-free manner in today's post-pandemic busy world.
                </span>
                <h6 className="white-text"> Our Vision</h6>
                <span>
                    At WelfareX, we believe in providing quality and compasssionate service to our customers.
                    Founded in 2020 with an importance of honesty and ease of procurement in mind, WelfareX has delivered excellency in urban aya care service over the last few years, as demonstrated by our outstanding reputation and client recommendations.  
                  <br/>
                    We are committed to making your lives easier.
                </span>
                <div className="row"></div>
            </div>
        )
    }
}
